import request from './request'
// 查询/获取项目地图服务
export function getProjectMap(projectId) {
  return request({
    url: `/map/project/${projectId}/getProjectMap`,
    method: 'GET'
  })
}
// 获取项目地图图层
export function getProjectMapLayers(projectId, token, seesionId) {
  return request({
    url: `/map/project/${projectId}/getProjectMapLayers`,
    method: 'GET'
  })
}
// 获取地图房屋面数据
export function getProjectMapCoordinates(projectId, layerId) {
  return request({
    url: `/map/project/${projectId}/getProjectMapCoordinates/${layerId}`,
    method: 'GET'
  })
}
// 获取地图图例
export function getMapLegend(projectId) {
  return request({
    url: `/map/project/${projectId}/getMapLegend`,
    method: 'GET'
  })
}
// 获取系统地图图层
export function getOrgMapServices(orgId) {
  return request({
    url: `/map/system/${orgId}/getOrgMapServices`,
    method: 'GET'
  })
}
// 查询/获取项目地图服务
export function getSystemMap(orgId, mapServiceId) {
  return request({
    url: `/map/system/${orgId}/getOrgMap/${mapServiceId}`,
    method: 'GET'
  })
}

// 获取区项目下地图
export function getCountyProjectMapLayers(orgId, projectId, params) {
  return request({
    url: `/map/system/project/${orgId}/getProjectMapLayers/${projectId}`,
    method: 'GET',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/request/mapApi.js